import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDkANO_DyFpHMI6ctJO3sWRDH9DbGk1-UI',
  authDomain: 'tsnw-volunteer-app.firebaseapp.com',
  databaseURL: 'https://tsnw-volunteer-app.firebaseio.com',
  projectId: 'tsnw-volunteer-app',
  storageBucket: 'tsnw-volunteer-app.appspot.com',
  messagingSenderId: '664716353221',
  appId: '1:664716353221:web:266f9ba2b22656b8ec9aac',
  measurementId: 'G-S7V32EC4T2',
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const fb = firebase;
